/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Shelf_DefaultInputs */

const vi_sales_return_shelf_default = /** @type {(inputs: Sales_Return_Shelf_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kệ mặc định`)
};

/**

* @param {Sales_Return_Shelf_DefaultInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_shelf_default = /** @type {((inputs?: Sales_Return_Shelf_DefaultInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Shelf_DefaultInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_shelf_default(inputs)
});